

















































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import {
  Button,
  Card,
  Checkbox,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  Tooltip
} from 'element-ui';
import BillTable from '@/components/bill/BillTable.vue';
import DeleteTemplate from '@/components/modals/inquiry/DeleteTemplate.vue';
import LoadTemplate from '@/components/modals/inquiry/LoadTemplate.vue';
import SaveTemplate from '@/components/modals/inquiry/SaveTemplate.vue';
import { shipmentService } from '@/services/ShipmentService';
import { inquiryService } from '@/services/InquiryService';
import {
  InquiryStatusEnum,
  ShipmentStatusEnum,
  QuoteHistoryFields,
  fetchInquiryQuote_inquiries,
  fetchShipmentQuote_shipments
} from '@/types/graphql/schemaTypes';
import get from 'lodash/get';

@Component({
  components: {
    BillTable,
    DeleteTemplate,
    LoadTemplate,
    SaveTemplate,
    'el-button': Button,
    'el-card': Card,
    'el-checkbox': Checkbox,
    'el-dropdown': Dropdown,
    'el-dropdown-item': DropdownItem,
    'el-dropdown-menu': DropdownMenu,
    'el-input': Input,
    'el-tooltip': Tooltip
  }
})

export default class QuoteDetails extends Vue {
  @Prop({ required: true }) shipment!: fetchShipmentQuote_shipments | fetchInquiryQuote_inquiries;
  @Prop({ default: 'inquiry' }) type!: 'inquiry' | 'shipment';

  public quoteHistory = this.generateQuoteHistory();
  public rate: number = this.shipment.usdJpyExchangeRate || 0;
  public taxRate: number = this.shipment.taxRate ? this.shipment.taxRate * 100 : 0;
  public isDeleteOpen = false;
  public isLoadOpen = false;
  public isSaveOpen = false;
  public showTotal = this.shipment.showTotal;
  private loading = false;

  public created() {
    this.$store.dispatch('BillItem/fetchTemplates');
  }

  public closeTemplateModal() {
    this.isDeleteOpen = false;
    this.isLoadOpen = false;
    this.isSaveOpen = false;
  }

  public handleCommand(command: string) {
    switch (command) {
      case 'load':
        this.isLoadOpen = true;
        break;
      case 'save':
        this.isSaveOpen = true;
        break;
      case 'delete':
        this.isDeleteOpen = true;
        break;
      default:
        break;
    }
  }

  public formatMoney(val: any) {
    const value = val ? val.toLocaleString() : '0';
    return this.$t('inquiry.quote.formatMoney', { value });
  }

  public async submit() {
    const args = {
      id: this.shipment.id,
      usdJpyExchangeRate: this.rate,
      taxRate: this.taxRate / 100,
      showTotal: this.showTotal
    };

    this.loading = true;

    try {
      let response;
      if (this.shipment.status in ShipmentStatusEnum) {
        response = await shipmentService.updateShipment(args);
      } else {
        response = await inquiryService.updateInquiry(args);
      }

      if (response) {
        this.$emit('refresh');
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.loading = false;
    }
  }

  public hasBill(): string | null {
    const billItem = (this.shipment.billItems || []).find((bi) => {
      return !!bi.billId;
    });
    return billItem ? billItem.billId : null;
  }

  get computeMarginPercent(): number {
    const total = this.shipment.billItemTotalSales || 0;
    const margin = this.shipment.billItemTotalMargin || 0;
    return total !== 0 ? Math.round((margin / total) * 10000) / 100 : 0;
  }

  public shipmentTaxRatePercent(): number {
    if (this.shipment && this.shipment.taxRate) {
      return this.shipment.taxRate * 100;
    }
    return 0;
  }

  public isInquiry(): boolean {
    return (
      this.shipment.status === InquiryStatusEnum.inquiry_quoted ||
      this.shipment.status === InquiryStatusEnum.inquiry_created
    );
  }

  public generateQuoteHistory(): QuoteHistoryFields[] {
    return this.shipment.quoteHistory.sort((a, b) => {
      return new Date(b.date).getTime() - new Date(a.date).getTime();
    });
  }

  public quotePdfUrl(url: string) {
    return `${url}&token=${this.getUserToken()}&role=operator`;
  }

  public getUserToken() {
    let token = '';
    const tokenName = 'X-Auth-Token';
    document.cookie.split(';').forEach((i) => {
      const pair = i.split('=');
      if (pair[0].trim() === tokenName) {
        token = pair[1];
      }
    });
    return token;
  }
}
